import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { RemunerationInitialState } from '../utils/Types';
import {
  getRemunerations,
  approveRejectRemuneration,
  getDetailedRemuneration,
} from '../services';
import { isAPISuccess } from '../utils/Util';
import { API_STATUS, BlankPagination } from '../utils/Constant';

export const initialState: RemunerationInitialState = {
  remunerationList: {
    status: '',
    responseInformation: {
      responseCode: '',
      responseMessage: '',
    },
    result: [],
    pagination: BlankPagination,
  },
};

export const getRemunerationList = createAsyncThunk(
  'remuneration/getRemunerationList',
  async (data: any) => {
    const res = await getRemunerations(data);
    return res.data;
  }
);

export const getCandidateRemuneration = createAsyncThunk(
  'remuneration/getCandidateRemuneration',
  async (data: any) => {
    const res = await getDetailedRemuneration(data);
    return res.data;
  }
);

export const approveOrRejectRemuneration = createAsyncThunk(
  'remuneration/approveOrReject',
  async (data: any) => {
    const res = await approveRejectRemuneration(data);
    return res.data;
  }
);

export const remunerationSlice = createSlice({
  name: 'remuneration',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(getRemunerationList.pending, (state) => {
        state.remunerationList.status = API_STATUS.LOADING;
      })
      .addCase(getRemunerationList.fulfilled, (state, action) => {
        if (isAPISuccess(action.payload)) {
          state.remunerationList.status = API_STATUS.SUCCEEDED;
          state.remunerationList.pagination = action.payload.pagination;
          state.remunerationList.result = action.payload.result;
          state.remunerationList.responseInformation =
            action.payload.responseInformation;
        } else {
          state.remunerationList.result = [];
          state.remunerationList.pagination = BlankPagination;
          state.remunerationList.status = API_STATUS.FAILED;
        }
      });
  },
});
export const remunerationSelector = (state: {
  remuneration: RemunerationInitialState;
}) => state.remuneration;

export default remunerationSlice.reducer;
